export const SET_WEB_SIGN_IN_CONFIRMATION = 'SET_WEB_SIGN_IN_CONFIRMATION';
export const GET_WEB_SIGN_IN_QR_CODE_STATUS_REQUEST = 'GET_WEB_SIGN_IN_QR_CODE_STATUS_REQUEST';
export const GET_WEB_SIGN_IN_QR_CODE_STATUS_SUCCESS = 'GET_WEB_SIGN_IN_QR_CODE_STATUS_SUCCESS';
export const GET_WEB_SIGN_IN_QR_CODE_STATUS_FAILURE = 'GET_WEB_SIGN_IN_QR_CODE_STATUS_FAILURE';
export const UPDATE_WEB_SIGN_IN_QR_CODE_STATUS_REQUEST = 'UPDATE_WEB_SIGN_IN_QR_CODE_STATUS_REQUEST';
export const UPDATE_WEB_SIGN_IN_QR_CODE_STATUS_SUCCESS = 'UPDATE_WEB_SIGN_IN_QR_CODE_STATUS_SUCCESS';
export const UPDATE_WEB_SIGN_IN_QR_CODE_STATUS_FAILURE = 'UPDATE_WEB_SIGN_IN_QR_CODE_STATUS_FAILURE';
export const RESET_WEB_SIGN_IN_CONFIRMATION = 'RESET_WEB_SIGN_IN_CONFIRMATION';
